import ResultItemContentType from './ResultItemContentType';
import solrConfig from '@package/solr.json';

const ResultItemContentTypeInGroup = ({ item, groupSelect }) =>
  solrConfig.searchTabs[groupSelect]?.showContentTypes ? (
    <ResultItemContentType item={item} />
  ) : null;

export default ResultItemContentTypeInGroup;
